import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { VersaFlexOptions } from 'libs/constants';
import { UnitType } from 'libs/constants/unit-of-measure.constants';
import { PumpScheduleService } from '../../../pump-schedule/services';
import { PumpScheduleStateManager } from '../../state/schedule-state-manager';
import { DocumentUrlKeyword } from '../../../shared/constant/document-url-keyword';
import { ApplicationStateService, ControlPointService2 } from 'libs/shared';
import { Job } from 'libs/models';

@Component({
    selector: 'liner',
    templateUrl: './liner.component.html',
    styleUrls: ['./liner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LinerComponent implements OnInit {

    public readonly UnitType = UnitType;
    public readonly VersaFlexOptions = VersaFlexOptions;
    public documentKeyword = DocumentUrlKeyword;

    public LinerCirculationMethods: any;
    public linearConfirmation: boolean = false;

    @Input() scheduleState!: PumpScheduleStateManager;
    @Input() isLinerParamsRequired!: boolean;
    @Input() controlPointType: any;

    private _job!: Job;
    @Input()
    set job(value: Job) {
        if (value) {
            this._job = value;
            this.linearConfirmation = value.isVersaFlexLiner;
            this.versaFlexForm.patchValue(value);
            this.cd.detectChanges();
        }
    }
    get job(): Job {
        return this._job;
    }

    public versaFlexForm = new UntypedFormGroup({
        isVersaFlexLiner: new UntypedFormControl(),
        versaFlexLinerConfirmation: new UntypedFormControl(),
        versaFlexLinerComment: new UntypedFormControl()
    });

    constructor(
        private pumpSchedule: PumpScheduleService,
        private controlPointService: ControlPointService2,
        private cd: ChangeDetectorRef,
        public applicationStateService: ApplicationStateService
    ) { }

    public get pumpScheduleForm(): UntypedFormGroup {
        return this.scheduleState.form;
    }


    ngOnInit() {
        this.pumpSchedule.getLinerCirculation().subscribe(res => {
            this.LinerCirculationMethods = res.map(item => {
                return {
                    value: item.id,
                    label: item.name
                }
            })
            this.cd.detectChanges();
        });

        this.versaFlexForm.controls.isVersaFlexLiner.valueChanges.subscribe((x) => {
            this.linearConfirmation = x;
            if (x)
                this.versaFlexForm.controls['versaFlexLinerConfirmation'].setValue(false);
        });
    }

    openLinerDocment(event: Event, flag: number) {
        event.preventDefault();
        this.controlPointService.getDesignDocumetUrl(flag).subscribe(result => {
            window.open(result.url, ' _blank');
        });
    }

    showError() {
        if (this.versaFlexForm.controls?.versaFlexLinerComment?.errors) {
            return true;
        }
    }

    isVersaFlexLinearChange() {
        this.applicationStateService.versaFlexLinear$.next(this.getRawValue());
    }

    versaFlexConfirmationChange() {
        this.applicationStateService.versaFlexLinear$.next(this.getRawValue());
    }

    versaFlexCommentChange() {
        this.applicationStateService.versaFlexLinear$.next(this.getRawValue());
    }

    getRawValue() {
        return this.versaFlexForm.getRawValue();
    }

    checkVersaFlexForm(): boolean {
        const vfValue = this.versaFlexForm.value;
        if (vfValue == null || vfValue == undefined) return false;
        if (this.versaFlexForm.controls['isVersaFlexLiner'].value == true) {
            const vfConfirmation = vfValue.versaFlexConfirmation as boolean;
            const vfComment = vfValue.versaFlexComment as string;

            this.versaFlexForm.controls['versaFlexLinerConfirmation'].setValidators(Validators.required);
            this.versaFlexForm.controls['versaFlexLinerConfirmation'].markAsTouched();
            this.versaFlexForm.controls['versaFlexLinerConfirmation'].updateValueAndValidity();

            if (!vfConfirmation && (vfComment == null || vfComment == '' || vfComment == undefined)) {
                this.versaFlexForm.controls['versaFlexLinerComment'].setValidators(Validators.required);
                this.versaFlexForm.controls['versaFlexLinerComment'].markAsTouched();
                this.versaFlexForm.controls['versaFlexLinerComment'].updateValueAndValidity();
                return false;
            }
            return true;
        }

    }

}
